import { searchFormStyles } from "@waytek/Overrides/Widgets/OrderHistory/OrderHistorySearchForm";
import { css } from "styled-components";

searchFormStyles.wrapper = {
    ...searchFormStyles.wrapper,
    css: css`
        width: calc(100% + 20px);
        margin-left: -10px;
        margin-bottom: 20px;
    `,
};

searchFormStyles.headingText = {
    ...searchFormStyles.headingText,
    size: 18,
    weight: 500,
    lineHeight: 1.33,
    css: css`
        padding-left: 10px;
        text-transform: none;
    `,
};
